/**
 * Image Configuration
 * 
 * Centralized image management for the entire site.
 * Update URLs here to change images across the site easily.
 */

export const images = {
  // Logo and branding
  logo: {
    main: '/images/logos/LOGO_PROPULSION_INDUSTRIES_COLOR1.png',
    favicon: '/images/logos/logo.jpg',
    alt: 'Propulsion Industries Logo',
  },

  // Home page gallery images
  gallery: [
    {
      id: 1,
      src: '/images/gallery/7d360d34-eef0-42a2-85d6-29b6624ca9dc.jpg',
      alt: 'Rocket launch at competition',
      title: 'Competition Launch',
    },
    {
      id: 2,
      src: '/images/gallery/20220924_144357.jpg',
      alt: 'Team assembling rocket',
      title: 'Team Assembly',
    },
    {
      id: 3,
      src: '/images/gallery/IMG_0537.jpeg',
      alt: 'Motor test fire',
      title: 'Motor Testing',
    },
    {
      id: 4,
      src: '/images/gallery/IMG-20220924-WA0039.jpg',
      alt: 'Team celebrating win',
      title: 'Victory',
    },
  ],

  // Team member photos (for when you add real photos)
  team: [
    {
      id: 1,
      name: 'Rodrigo Hernández',
      src: '/images/team/rodrigo.jpg',
      alt: 'Rodrigo Hernández - CEO',
      fallback: '👨‍🚀',
    },
    {
      id: 2,
      name: 'Godric Aceves',
      src: '/images/team/godric.jpg',
      alt: 'Godric Aceves - CTO',
      fallback: '👩‍💻',
    },
    {
      id: 3,
      name: 'Alberto Ojeda',
      src: '/images/team/alberto.jpg',
      alt: 'Alberto Ojeda - Head of Manufacturing',
      fallback: '👨‍🔧',
    },
    {
      id: 4,
      name: 'Luis Cosio',
      src: '/images/team/luis.jpg',
      alt: 'Luis Cosio - Research Director',
      fallback: '👩‍🔬',
    },
    {
      id: 5,
      name: 'Marian Munguía',
      src: '/images/team/marian.jpg',
      alt: 'Marian Munguía - Competition Team Lead',
      fallback: '🏆',
    },
    {
      id: 6,
      name: 'Bruno Alvarado',
      src: '/images/team/bruno.jpg',
      alt: 'Bruno Alvarado - Business Development',
      fallback: '💼',
    },
  ],

  // Project images
  projects: {
    phoenixMotor: '/images/projects/phoenix-motor.jpg',
    aguilaRocket: '/images/projects/aguila-rocket.jpg',
    recoverySystem: '/images/projects/recovery-system.jpg',
    quetzalRocket: '/images/projects/quetzal-rocket.jpg',
    researchPlatform: '/images/projects/research-platform.jpg',
    marsSimulation: '/images/projects/mars-simulation.jpg',
  },

  // Competition/Event images
  competitions: {
    enmice2025: '/images/competitions/enmice-2025.jpg',
    enmice2024: '/images/competitions/enmice-2024.jpg',
    bajaRocket: '/images/competitions/baja-rocket.jpg',
    enmice2023: '/images/competitions/enmice-2023.jpg',
    lasc2023: '/images/competitions/lasc-2023.jpg',
  },

  // Sponsor logos
  sponsors: [
    {
      id: 1,
      name: 'Sponsor 1',
      src: '/images/sponsors/sponsor-1.png',
      alt: 'Sponsor 1 Logo',
      link: 'https://sponsor1.com',
    },
    {
      id: 2,
      name: 'Sponsor 2',
      src: '/images/sponsors/sponsor-2.png',
      alt: 'Sponsor 2 Logo',
      link: 'https://sponsor2.com',
    },
  ],

  // Background/Hero images
  backgrounds: {
    homeHero: '/images/headers/IMG_8487.jpeg',
    aboutHero: '/images/headers/20230825_191738984_iOS.JPG',
    projectsHero: '/images/headers/IMG_8488.jpeg',
    contactHero: '/images/headers/IMG_6763.jpeg',
  },
}

export default images
